/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Messages_LabelInputs */

const en_us2_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation with the trainer`)
};

const pt_br2_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa com o personal`)
};

const es_419_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación con el entrenador`)
};

const pt_pt2_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa com o treinador`)
};

const fr_fr2_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation avec le coach`)
};

const de_de2_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung mit dem Coach`)
};

const it_it2_coach_messages_label = /** @type {(inputs: Coach_Messages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazione con il coach`)
};

/**
* | output |
* | --- |
* | "Conversation with the trainer" |
*
* @param {Coach_Messages_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_messages_label = /** @type {((inputs?: Coach_Messages_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Messages_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_messages_label(inputs)
	if (locale === "es-419") return es_419_coach_messages_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_messages_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_messages_label(inputs)
	if (locale === "de-DE") return de_de2_coach_messages_label(inputs)
	if (locale === "it-IT") return it_it2_coach_messages_label(inputs)
	return en_us2_coach_messages_label(inputs)
});
export { coach_messages_label as "coach.messages_label" }